import { CContainer } from '@coreui/react';
import React, { type ReactNode } from 'react';
import { Breadcrumbs } from '../Breadcrumbs';
import type { BreadcrumbItem } from './types';

export type { BreadcrumbItem } from './types';

interface PageLayoutProps {
  children: ReactNode;
  customBreadcrumbLabels?: Record<string, string>;
  breadcrumbItems?: BreadcrumbItem[];
}

export const PageLayout: React.FC<PageLayoutProps> = ({
  children,
  customBreadcrumbLabels,
  breadcrumbItems,
}) => {
  return (
    <>
      <div className="breadcrumb-container">
        <CContainer fluid>
          <Breadcrumbs items={breadcrumbItems} customLabels={customBreadcrumbLabels} />
        </CContainer>
      </div>
      <CContainer fluid className="mt-4 mb-4">
        {children}
      </CContainer>
    </>
  );
};
